import { styleToClass } from "@/styles/styleLineToClass";
import { radius } from "@/styles/tokens/spacing/radius";
import { useThemeToken } from "@/styles/tokens/useThemeTokens";
import { camelToSnake } from "@/utils/changeVarsPatten";

const { getColors, colors, getSpacing, getTypography } = useThemeToken();
const { spacing_8xl, spacing_4xl, spacing_2xl, spacing_lg, spacing_sm } =
	getSpacing;
const { size, weight, lineHeight } = getTypography;

const flexColumn: React.CSSProperties = {
	display: "flex",
	flexDirection: "column",
};

const loginFormContainer: React.CSSProperties = {
	...flexColumn,
	backgroundColor: "#ffffff",
	justifyContent: "space-between",
	width: "50%",
	maxWidth: "640px",
	minWidth: "480px",
};
const loginFormContent = {
	...flexColumn,
	width: "100%",
	maxWidth: "360px",
	gap: spacing_8xl,
	margin: "auto",
};

const loginSection: React.CSSProperties = {
	...flexColumn,
	gap: spacing_4xl,
};

const loginTextBlock: React.CSSProperties = {
	...flexColumn,
	gap: spacing_lg,
};

const loginTextTitle: React.CSSProperties = {
	fontSize: size.display_md,
	fontWeight: weight.semibold,
	color: colors.text.text_primary,
	lineHeight: lineHeight.display_md,
};

const loginTextSubtitle: React.CSSProperties = {
	fontSize: size.text_md,
	fontWeight: weight.regular,
	color: getColors.text_tertiary,
	textAlign: "left",
	whiteSpace: "pre-line",
};

const loginBrand: React.CSSProperties = {
	color: colors.text.text_tertiary,
	fontSize: size.text_sm,
	fontWeight: weight.regular,
	lineHeight: lineHeight.text_sm,
	padding: spacing_4xl,
};

const loginForm: React.CSSProperties = {
	...flexColumn,
	width: "100%",
	gap: spacing_2xl,
};

const loginTextField: React.CSSProperties = {
	gap: spacing_sm,
};

const loginFormLabel: React.CSSProperties = {
	fontSize: size.text_sm,
	fontWeight: weight.medium,
	color: getColors.text_tertiary,
	textAlign: "left",
	whiteSpace: "pre-line",
} as const;

const loginBtnSubmit: React.CSSProperties = {
	backgroundColor: getColors.bg_brand_solid,
	color: colors.text.text_white,
	fontSize: size.text_md,
	fontWeight: weight.semibold,
};

const loginContainerImage: React.CSSProperties = {
	backgroundColor: getColors.bg_brand_solid,
	position: "relative",
	overflow: "hidden",
	display: "flex",
	alignItems: "center",
	paddingLeft: "40px",
	alignContent: "center",
	justifyContent: "center",
	width: "100%",
};

const loginImage = {
	sm: {
		borderRadius: radius.radius_3xl,
		position: "absolute",
		left: "10%",
		width: "1017px",
	},
	xl: {
		borderRadius: radius.radius_3xl,
		position: "absolute",
		left: "10%",
		width: "1017px",
	},
	"2xl": {
		borderRadius: radius.radius_3xl,
		position: "absolute",
		left: "10%",
		width: "1240px",
	},
	"3xl": {
		borderRadius: radius.radius_3xl,
		width: "1240px",
	},
};

const loginErrorMessage: React.CSSProperties = {
	color: getColors.text_error_primary,
	fontSize: size.text_sm,
	fontWeight: weight.regular,
	lineHeight: lineHeight.text_sm,
};
const loginErrorInput: React.CSSProperties = {
	color: getColors.text_error_primary,
	border: `1px solid ${getColors.border_error_subtle}`,
	borderRadius: radius.radius_md,
	boxShadow: "0 1px 2px 0 rgba(10, 13, 18, 0.05)",
};

export const loginStyles = () => {
	const styleInLine = {
		loginFormContainer,
		loginFormContent,
		loginSection,
		loginTextBlock,
		loginTextTitle,
		loginTextSubtitle,
		loginBrand,
		loginForm,
		loginTextField,
		loginFormLabel,
		loginBtnSubmit,
		loginContainerImage,
		loginImage,
		loginErrorMessage,
		loginErrorInput,
	};
	const classes = Object.entries(styleInLine).reduce(
		(acc, [key, value]) => {
			const snakeKey = camelToSnake(key);
			styleToClass(value, snakeKey);
			acc[snakeKey] = snakeKey;
			return acc;
		},
		{} as Record<string, string>
	);

	return {
		classes,
		styleInLine,
	};
};
